<div class="main">
  @if (dataLoading | async) {
    <ds-localized-spinner
      class="block pad-bottom-20"
      [dataLoading]="dataLoading | async"
      [loadingMessage]="'Looking for FAQ...'"
    >
    </ds-localized-spinner>
  }
  @if ((dataLoading | async) === false) {
    <div class="row">
      <ds-amfam-faq-links
        [isPartner]="isPartner | async"
        class="column twelve md-two"
      ></ds-amfam-faq-links>
      @if (!!content && (isPartner | async) === false) {
        <ds-amfam-faq class="column twelve md-ten">
          <ng-container header>Frequently Asked Questions</ng-container>
          <ng-container questions>
            <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
              <ds-accordion-category
                [title]="checklist.title"
                [startOpen]="checklistStartOpen | async"
                data-cy="faqQuestion"
              >
                @for (item of checklist.checklistItems; track item; let idx = $index) {
                  <div data-cy="faqAnswer">
                    <span class="font-weight-bold">{{ idx + 1 }}. {{ item.item }}</span>
                    @for (subItem of item.subItems; track subItem) {
                      <div class="margin-left-30 margin-right-30">
                        {{ subItem.item }}
                        <ul class="bullet margin-left-30">
                          @for (subItemTwo of subItem.subItems; track subItemTwo) {
                            <li class="margin-bottom-0">
                              {{ subItemTwo.item }}
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                }
                @if (claimsFNOLEnabled && impersonating$ | async) {
                  <button
                    ds-button
                    class="margin-top-10 -outline margin-right-10"
                    type="button"
                    dsContent
                    [contentPath]="'claims.reportClaimBtn'"
                    authCheck
                    [permissionName]="'fnolform_view'"
                    [checkAction]="'remove'"
                    (click)="deriveRouting()"
                  ></button>
                }
                @if (!claimsFNOLEnabled) {
                  <button
                    ds-button
                    type="button"
                    dsRouterLink="/claims/report-claim"
                    dsContent
                    [contentPath]="'claims.reportClaimBtn'"
                  ></button>
                }
              </ds-accordion-category>
              @for (question of content; track question) {
                <ds-accordion-category
                  data-cy="faqQuestion"
                  [title]="question | splitAndGet: '^' : 0"
                >
                  <p data-cy="faqAnswer">{{ question | splitAndGet: '^' : 1 }}</p>
                </ds-accordion-category>
              }
            </ds-accordion>
          </ng-container>
        </ds-amfam-faq>
      }
      @if (!!(isPartner | async) && !!(partnerPropertyContent | async)) {
        <amfam-faq class="column twelve md-ten">
          <ng-container header>Property</ng-container>
          <ng-container questions>
            <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
              @for (question of partnerPropertyContent | async; track question) {
                <ds-accordion-category [title]="question.title">
                  <p [innerHtml]="question.body"></p>
                </ds-accordion-category>
              }
            </ds-accordion>
          </ng-container>
        </amfam-faq>
      }
      @if (!!(isPartner | async) && !!(partnerAutoContent | async)) {
        <amfam-faq class="margin-top-40 column twelve md-ten float-right" [hideSidebar]="true">
          <ng-container header>Auto</ng-container>
          <ng-container questions>
            <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
              @for (question of partnerAutoContent | async; track question) {
                <ds-accordion-category [title]="question.title">
                  <p [innerHtml]="question.body"></p>
                </ds-accordion-category>
              }
            </ds-accordion>
          </ng-container>
        </amfam-faq>
      }
      <!-- AS: This also needs to be shown in case the site core is down -->
      @if ((dataLoading | async) === false && (isPartner | async) === false) {
        <div class="row pad-top-20">
          <div class="column twelve md-push-two">
            <p>
              Still have questions? View the
              <a [href]="amfamDotComFaqUrl" target="_blank">Claims FAQ</a> or call us
            </p>
          </div>
        </div>
      }
    </div>
  }
</div>
